import http from '../services/http';
import { typeAs } from '../services/utils';
import Str from '../services/str';

export default {
  namespaced: true,

  state: {
    qacategoryList: [],
    qacategory: null,
    links: null,
    meta: null,
    filter: {
      keyword: '',
      tab: '',
      status: '',
    },
  },

  mutations: {
    CLEAR_ALL(state) {
      state.qacategoryList = [];
      state.qacategory = null;
    },
    SET_QACATEGORYLIST(state, data) {
      state.qacategoryList = data.data.map(
        (item) => {
          item.isChecked = false;
          return item;
        },
      );
      state.links = data.links;
      state.meta = data.meta;
    },
    SET_QACATEGORY(state, data) {
      state.qacategory = data;
    },
    SET_FILTER(state, data) {
      state.filter = data;
    },
    SET_META(state, data) {
      state.meta = data;
    },
  },

  actions: {
    clear({ commit }) {
      commit('CLEAR_ALL');
    },

    setFilter({ commit }, data) {
      commit('SET_FILTER', data);
    },

    setMeta({ commit }, data) {
      commit('SET_META', data);
    },

    setQACategory({ commit }, data) {
      commit('SET_QACATEGORY', data);
    },

    find({ commit, state }) {
      let url = `/faq-category?${Str.query(state.filter)}`;
      if (state.meta) {
        url += `&page=${state.meta.current_page}&page_count=${state.meta.per_page}`;
      }
      return http(url)
        .then((response) => {
          response.body.data.map(typeAs('qacategory'));
          return response.body;
        })
        .then((response) => {
          commit('SET_QACATEGORYLIST', response);
        });
    },

    findById({ commit }, id) {
      return http(`/faq-category/${id}`)
        .then((response) => response.body)
        .then(typeAs('qacategory'))
        .then((item) => {
          commit('SET_QACATEGORY', item);
        });
    },

    destroy(_, id) {
      return http(`/faq-category/${id}`, { method: 'DELETE' })
        .then((response) => response.body);
    },

    save(_, {
      id, ...data
    }) {
      const request = id
        ? http(`/faq-category/${id}`, { method: 'PUT', data })
        : http('/faq-category', { method: 'POST', data });
      console.log(data);
      return request.then((response) => response.body);
    },

    changeStatus(_, {
      id, ...data
    }) {
      const request = http(`/faq-category/${id}/status`, { method: 'PUT', data });

      return request.then((response) => response.body);
    },

    // 取得所屬問與答分類[Warranty or FAQ or RMA]
    getSupportQACates(_, id) {
      const request = id
        ? http(`/supportcatebyID/QA/${id}`)
        : http('/supportcates/QA/all');
      return request.then((response) => response.body);
    },
    // 取得所屬檔案下載分類
    getSupportFilesCates(_, id) {
      const request = id
        ? http(`/supportcatebyID/Files/${id}`)
        : http('/supportcates/Files/all');
      return request.then((response) => response.body);
    },
  },
};
